import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dataContainer"]
  static values = {
    sheetId: String
  }

  copyWithHeaders(event) {
    event.preventDefault()
    this.copyToClipboard(true, event.currentTarget)
  }

  copyWithoutHeaders(event) {
    event.preventDefault()
    this.copyToClipboard(false, event.currentTarget)
  }

  copyToClipboard(includeHeaders, button) {
    const dataContainer = this.dataContainerTarget
    const columns = JSON.parse(dataContainer.dataset.columns)
    const rows = JSON.parse(dataContainer.dataset.rows)

    // Build TSV (Tab-Separated Values) for easy paste into Excel/Sheets
    let tsvData = []

    // Add headers if requested
    if (includeHeaders) {
      tsvData.push(columns.join('\t'))
    }

    // Add data rows
    rows.forEach(row => {
      tsvData.push(row.join('\t'))
    })

    const textToCopy = tsvData.join('\n')

    // Try modern clipboard API first
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(textToCopy).then(() => {
        this.showFeedback(button, includeHeaders)
      }).catch(err => {
        console.error('Clipboard API failed:', err)
        this.fallbackCopy(textToCopy, button)
      })
    } else {
      // Use fallback for older browsers or non-secure contexts
      this.fallbackCopy(textToCopy, button)
    }
  }

  fallbackCopy(text, button) {
    // Create a temporary textarea
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.style.position = 'fixed'
    textarea.style.left = '-9999px'
    textarea.style.top = '0'
    document.body.appendChild(textarea)

    // Select and copy
    textarea.focus()
    textarea.select()

    try {
      const successful = document.execCommand('copy')
      if (successful) {
        this.showFeedback(button, true)
      } else {
        alert('Failed to copy to clipboard. Please try selecting and copying manually.')
      }
    } catch (err) {
      console.error('Fallback copy failed:', err)
      alert('Failed to copy to clipboard. Please try selecting and copying manually.')
    } finally {
      document.body.removeChild(textarea)
    }
  }

  showFeedback(button, includeHeaders) {
    const originalHTML = button.innerHTML
    const originalClass = button.className

    // Show success feedback
    button.innerHTML = '<i class="bi bi-check-circle"></i> Copied!'
    button.classList.remove('btn-outline-primary', 'btn-outline-secondary')
    button.classList.add('btn-success')

    setTimeout(() => {
      button.innerHTML = originalHTML
      button.className = originalClass
    }, 2000)
  }
}
